import { ClientDto } from "@merchant_api/models/client-dto";

export class ClientsState {
    loading = false;
    error = null;
    record: Array<ClientDto> = [];
}
